/* ==========================================================================
   THE RING AUTHORITY: PAGE BEHAVIOUR
   --------------------------------------------------------------------------
   You do not need to edit this file. All settings live in config.js.

   What this file does:
     1. Reads your settings
     2. Fills in WhatsApp links, trust claim, testimonials
     3. Runs the two-step form, including validation and error messages
     4. Captures UTM parameters and GCLID from the ad click
     5. Sends the enquiry to your webhook
     6. Runs the FAQ accordion, gallery and sticky mobile button
   ========================================================================== */

(function () {
  'use strict';

  var C = window.TRA_CONFIG || {};
  var track = window.traTrack || function () {};

  function isSet(v) {
    return typeof v === 'string' && v.length > 0 &&
           v.indexOf('X') === -1 && v.indexOf('YOUR_') === -1;
  }

  var WEBHOOK_READY = isSet(C.LEAD_WEBHOOK_URL);
  var WHATSAPP_READY = isSet(C.WHATSAPP_NUMBER) && /^[0-9]{6,}$/.test(C.WHATSAPP_NUMBER);

  var fired = {};
  function trackOnce(event, params) {
    if (fired[event]) return;
    fired[event] = true;
    track(event, params);
  }

  /* ======================================================================
     SETUP WARNINGS
     Shown only while previewing on your own computer, never to visitors
     on a live website.
     ====================================================================== */
  function isPreview() {
    var h = window.location.hostname;
    return window.location.protocol === 'file:' ||
           h === 'localhost' || h === '127.0.0.1' || h === '';
  }

  function showSetupNotice() {
    if (!isPreview()) return;

    var todo = [];
    if (!WEBHOOK_READY)  todo.push('Leads are not connected yet. Add LEAD_WEBHOOK_URL in config.js, or enquiries will go nowhere.');
    if (!WHATSAPP_READY) todo.push('WhatsApp number not set. The WhatsApp buttons are hidden until you add WHATSAPP_NUMBER in config.js.');
    if (!window.TRA_TRACKING || (!window.TRA_TRACKING.gtm && !window.TRA_TRACKING.ads)) {
      todo.push('Google Ads conversion tracking is not set up yet. Add your IDs in config.js before spending on ads.');
    }
    var placeholders = document.querySelectorAll('img[src*="images/"]').length;
    if (placeholders) todo.push('Replace the ' + placeholders + ' placeholder images in the images folder with real TRA project photos.');

    if (!todo.length) return;

    var bar = document.createElement('div');
    bar.className = 'setup-notice';
    var html = '<strong>Setup checklist</strong> <span class="setup-note">(you are previewing on your own computer, visitors never see this)</span><ul>';
    todo.forEach(function (t) { html += '<li>' + t + '</li>'; });
    html += '</ul><button type="button" class="setup-close" aria-label="Hide checklist">Hide</button>';
    bar.innerHTML = html;
    document.body.appendChild(bar);
    bar.querySelector('.setup-close').addEventListener('click', function () { bar.remove(); });
  }

  /* ======================================================================
     APPLY SETTINGS
     ====================================================================== */
  function applyConfig() {

    // ---- Trust claim ----
    var claim = document.getElementById('trust-claim');
    if (claim) {
      if (C.SHOW_TRUST_CLAIM === true && C.TRUST_CLAIM_TEXT) {
        claim.textContent = C.TRUST_CLAIM_TEXT;
        claim.hidden = false;
      } else if (C.SHOW_TRUST_FALLBACK === true && C.TRUST_FALLBACK_TEXT) {
        claim.textContent = C.TRUST_FALLBACK_TEXT;
        claim.hidden = false;
      }
    }

    // ---- Testimonials ----
    var section = document.getElementById('testimonials');
    var list = document.getElementById('quotes');
    var items = C.TESTIMONIALS || [];
    if (section && list && C.SHOW_TESTIMONIALS === true && items.length) {
      list.innerHTML = '';
      items.slice(0, 3).forEach(function (t) {
        if (!t || !t.quote || !t.name) return;
        var li = document.createElement('li');
        var bq = document.createElement('blockquote');
        bq.textContent = t.quote;
        var cite = document.createElement('cite');
        cite.textContent = t.name + (t.org ? ', ' + t.org : '');
        li.appendChild(bq); li.appendChild(cite);
        list.appendChild(li);
      });
      if (list.children.length) section.hidden = false;
    }

    // ---- WhatsApp ----
    var waLinks = document.querySelectorAll('[data-whatsapp]');
    if (WHATSAPP_READY) {
      var url = 'https://wa.me/' + C.WHATSAPP_NUMBER +
                '?text=' + encodeURIComponent(C.WHATSAPP_MESSAGE || '');
      Array.prototype.forEach.call(waLinks, function (el) {
        el.setAttribute('href', url);
        el.setAttribute('rel', 'noopener');
        el.addEventListener('click', function () {
          track('whatsapp_click', { location: el.getAttribute('data-whatsapp') });
        });
      });
    } else {
      // No number set. Hide the whole block rather than link to nothing.
      Array.prototype.forEach.call(document.querySelectorAll('[data-whatsapp-block]'), function (el) {
        el.hidden = true;
      });
    }

    // ---- Privacy link ----
    var privacy = document.querySelectorAll('[data-privacy-block]');
    Array.prototype.forEach.call(privacy, function (el) {
      if (isSet(C.PRIVACY_URL)) {
        var a = el.querySelector('a');
        if (a) a.setAttribute('href', C.PRIVACY_URL);
      } else {
        el.hidden = true;
      }
    });

    // ---- Year ----
    var year = document.getElementById('year');
    if (year) year.textContent = new Date().getFullYear();
  }

  /* ======================================================================
     ATTRIBUTION: UTM parameters and GCLID
     ====================================================================== */
  var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term',
                   'utm_content', 'gclid', 'gbraid', 'wbraid'];

  function captureAttribution() {
    var qs = new URLSearchParams(window.location.search);
    var stored = {};
    try { stored = JSON.parse(sessionStorage.getItem('tra_attr') || '{}'); } catch (e) {}

    ATTR_KEYS.forEach(function (key) {
      var value = qs.get(key) || stored[key] || '';
      if (value) stored[key] = value;
      var field = document.getElementById(key);
      if (field) field.value = value;
    });

    try { sessionStorage.setItem('tra_attr', JSON.stringify(stored)); } catch (e) {}

    var lp = document.getElementById('landing_page');
    if (lp) lp.value = window.location.href;
    var ref = document.getElementById('referrer');
    if (ref) ref.value = document.referrer || '';
  }

  /* ======================================================================
     Everything below needs the form. Pages without it (thank-you) stop here.
     ====================================================================== */
  captureAttribution();
  applyConfig();

  var form = document.getElementById('mockup-form');
  if (!form) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showSetupNotice);
    } else { showSetupNotice(); }
    initAccordion();
    return;
  }

  var step1 = form.querySelector('[data-step="1"]');
  var step2 = form.querySelector('[data-step="2"]');
  var bars  = document.querySelectorAll('.progress-bar');
  var recap = document.getElementById('recap');

  /* ---------- Option buttons instead of dropdowns ---------- */
  Array.prototype.forEach.call(form.querySelectorAll('.opt'), function (btn) {
    btn.addEventListener('click', function () {
      var name = btn.getAttribute('data-name');
      Array.prototype.forEach.call(
        form.querySelectorAll('.opt[data-name="' + name + '"]'),
        function (sib) { sib.setAttribute('aria-checked', 'false'); }
      );
      btn.setAttribute('aria-checked', 'true');
      var hidden = document.getElementById(name);
      if (hidden) hidden.value = btn.getAttribute('data-value');
      clearError(name);
      trackOnce('form_start', { form_name: 'mockup_request' });
    });

    btn.addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].indexOf(e.key) === -1) return;
      e.preventDefault();
      var group = Array.prototype.slice.call(
        form.querySelectorAll('.opt[data-name="' + btn.getAttribute('data-name') + '"]'));
      var i = group.indexOf(btn);
      var next = (e.key === 'ArrowRight' || e.key === 'ArrowDown')
        ? (i + 1) % group.length : (i - 1 + group.length) % group.length;
      group[next].focus(); group[next].click();
    });
  });

  form.addEventListener('input', function () {
    trackOnce('form_start', { form_name: 'mockup_request' });
  });

  /* ---------- Step navigation ---------- */
  function showStep(n) {
    step1.hidden = n !== 1;
    step2.hidden = n !== 2;
    Array.prototype.forEach.call(bars, function (bar) {
      bar.classList.toggle('is-active', parseInt(bar.getAttribute('data-bar'), 10) <= n);
    });
  }

  document.getElementById('to-step-2').addEventListener('click', function () {
    var product = document.getElementById('product').value;
    var size    = document.getElementById('ring_size').value;
    var ok = true;

    if (!product) { setError('product', 'Choose what you need so we can quote it.'); ok = false; }
    if (!size)    { setError('ring_size', 'Choose a ring size, or select Not sure.'); ok = false; }
    if (!ok) {
      var firstErr = form.querySelector('.err:not([hidden])');
      if (firstErr) firstErr.scrollIntoView({ block: 'center' });
      return;
    }

    // The step 1 answers sit on hidden inputs, so they carry through to
    // step 2 and into the submission automatically.
    if (recap) { recap.textContent = product + ' · ' + size; recap.hidden = false; }

    track('step_1_complete', {
      form_name: 'mockup_request',
      selected_product: product,
      ring_size: size
    });

    showStep(2);
    document.getElementById('mockup').scrollIntoView({ block: 'start' });
    window.setTimeout(function () { document.getElementById('full_name').focus(); }, 260);
  });

  document.getElementById('to-step-1').addEventListener('click', function () {
    showStep(1);
    document.getElementById('mockup').scrollIntoView({ block: 'start' });
  });

  /* ---------- Validation ---------- */
  function setError(id, message) {
    var box = document.getElementById('err-' + id);
    var input = document.getElementById(id);
    if (box) { box.textContent = message; box.hidden = false; }
    if (input && input.type !== 'hidden') {
      input.classList.add('is-invalid');
      input.setAttribute('aria-invalid', 'true');
      if (box) input.setAttribute('aria-describedby', 'err-' + id);
    }
  }

  function clearError(id) {
    var box = document.getElementById('err-' + id);
    var input = document.getElementById(id);
    if (box) { box.hidden = true; box.textContent = ''; }
    if (input) { input.classList.remove('is-invalid'); input.removeAttribute('aria-invalid'); }
  }

  var RULES = {
    full_name: { test: function (v) { return v.trim().length >= 2; },
                 msg: 'Please add your name so we know who to reply to.' },
    company:   { test: function (v) { return v.trim().length >= 2; },
                 msg: 'Please add your gym or company name.' },
    email:     { test: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()); },
                 msg: 'Please check your email address so we can send your mockup.' },
    phone:     { test: function (v) { return v.replace(/[^0-9]/g, '').length >= 8; },
                 msg: 'Please check your number.' }
  };

  Object.keys(RULES).forEach(function (id) {
    var input = document.getElementById(id);
    if (!input) return;
    input.addEventListener('blur', function () {
      if (!input.value.trim()) { clearError(id); return; }
      if (!RULES[id].test(input.value)) setError(id, RULES[id].msg); else clearError(id);
    });
    input.addEventListener('input', function () {
      if (input.classList.contains('is-invalid')) clearError(id);
    });
  });

  var artwork = document.getElementById('artwork');
  if (artwork) {
    artwork.addEventListener('change', function () {
      clearError('artwork');
      var file = artwork.files && artwork.files[0];
      var limit = C.MAX_UPLOAD_MB || 10;
      if (file && file.size > limit * 1024 * 1024) {
        setError('artwork', 'That file is over ' + limit + ' MB. Send a smaller version or attach it later.');
        artwork.value = '';
      }
    });
  }

  function validateStep2() {
    var ok = true;
    Object.keys(RULES).forEach(function (id) {
      var input = document.getElementById(id);
      if (!input) return;
      if (!input.value.trim()) { setError(id, 'Please add this so we can prepare your quote.'); ok = false; }
      else if (!RULES[id].test(input.value)) { setError(id, RULES[id].msg); ok = false; }
      else clearError(id);
    });
    return ok;
  }

  /* ---------- Submission ---------- */
  var submitBtn = document.getElementById('submit-btn');
  var busy = false;

  function resetButton() {
    busy = false;
    submitBtn.disabled = false;
    submitBtn.querySelector('.btn-label').textContent = 'Get My Free Mockup & Quote';
    submitBtn.querySelector('.spinner').hidden = true;
  }

  function failMessage() {
    var formErr = document.getElementById('err-form');
    formErr.innerHTML = WHATSAPP_READY
      ? 'We could not send that just now. Please try again, or <a href="https://wa.me/' +
        C.WHATSAPP_NUMBER + '">message us on WhatsApp</a>.'
      : 'We could not send that just now. Please try again in a moment.';
    formErr.hidden = false;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;

    // Honeypot: a real person never fills this in.
    if (document.getElementById('company_url').value) return;

    var formErr = document.getElementById('err-form');
    formErr.hidden = true;

    if (!validateStep2()) {
      var first = form.querySelector('.is-invalid');
      if (first) { first.focus(); first.scrollIntoView({ block: 'center' }); }
      return;
    }

    var data = new FormData(form);
    data.append('submitted_at', new Date().toISOString());
    data.append('page_url', window.location.href);

    // No webhook configured. Say so honestly rather than pretending it worked.
    if (!WEBHOOK_READY) {
      console.warn(
        '[The Ring Authority] FORM NOT CONNECTED.\n' +
        'No LEAD_WEBHOOK_URL is set in config.js, so this enquiry was not sent anywhere.\n' +
        'The enquiry that would have been sent:',
        Object.fromEntries(data.entries())
      );
      if (isPreview()) {
        formErr.innerHTML = '<strong>Preview mode: the form is not connected yet.</strong><br>' +
          'The form itself works. Add your LEAD_WEBHOOK_URL in config.js so enquiries reach you. ' +
          'Open your browser console to see the data that would have been sent.';
      } else {
        failMessage();
      }
      formErr.hidden = false;
      return;
    }

    busy = true;
    submitBtn.disabled = true;
    submitBtn.querySelector('.btn-label').textContent = 'Sending';
    submitBtn.querySelector('.spinner').hidden = false;

    var email = String(data.get('email') || '').trim().toLowerCase();
    var phone = String(data.get('phone') || '').replace(/[^0-9+]/g, '');

    function onSuccess() {
      track('form_submit', {
        form_name: 'mockup_request',
        selected_product: data.get('product'),
        ring_size: data.get('ring_size'),
        enhanced_conversion_data: { email: email, phone_number: phone }
      });

      // Pass the details to the thank-you page so the Google Ads
      // conversion can include them for Enhanced Conversions.
      try {
        sessionStorage.setItem('tra_lead', JSON.stringify({
          email: email, phone: phone,
          product: data.get('product'), ring_size: data.get('ring_size')
        }));
      } catch (err) {}

      window.location.href = C.THANK_YOU_URL || 'thank-you.html';
    }

    var options = { method: 'POST', body: data };
    if (C.WEBHOOK_NO_CORS_MODE === true) options.mode = 'no-cors';

    fetch(C.LEAD_WEBHOOK_URL, options)
      .then(function (res) {
        // In no-cors mode the browser hides the response, so a request
        // that did not throw is treated as delivered.
        if (C.WEBHOOK_NO_CORS_MODE === true) { onSuccess(); return; }
        if (!res.ok) throw new Error('Status ' + res.status);
        onSuccess();
      })
      .catch(function (err) {
        console.error('[The Ring Authority] Lead submission failed:', err);
        resetButton();
        failMessage();
      });
  });

  /* ---------- FAQ accordion ---------- */
  function initAccordion() {
    Array.prototype.forEach.call(document.querySelectorAll('.acc-trigger'), function (trigger) {
      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') === 'true';
        Array.prototype.forEach.call(document.querySelectorAll('.acc-trigger'), function (other) {
          other.setAttribute('aria-expanded', 'false');
          var panel = document.getElementById(other.getAttribute('aria-controls'));
          if (panel) panel.hidden = true;
        });
        if (!open) {
          trigger.setAttribute('aria-expanded', 'true');
          document.getElementById(trigger.getAttribute('aria-controls')).hidden = false;
          track('faq_open', { question: trigger.textContent.trim() });
        }
      });
    });
  }
  initAccordion();

  /* ---------- Sticky mobile button ---------- */
  var sticky = document.getElementById('sticky-cta');
  var formSection = document.getElementById('mockup');
  var hero = document.querySelector('.hero');

  if (sticky && formSection && hero && 'IntersectionObserver' in window) {
    var formInView = false, scrolledPast = false, hideTimer;

    function updateSticky() {
      var show = scrolledPast && !formInView;
      window.clearTimeout(hideTimer);
      if (show) {
        sticky.hidden = false;
        window.requestAnimationFrame(function () { sticky.classList.add('is-visible'); });
      } else {
        sticky.classList.remove('is-visible');
        // Remove from the keyboard tab order once it has slid away.
        hideTimer = window.setTimeout(function () { sticky.hidden = true; }, 220);
      }
    }

    // The small inset stops the form counting as "on screen" when it is
    // only touching the edge of the viewport.
    new IntersectionObserver(function (entries) {
      formInView = entries[0].isIntersecting; updateSticky();
    }, { threshold: 0, rootMargin: '-8px 0px -8px 0px' }).observe(formSection);

    new IntersectionObserver(function (entries) {
      scrolledPast = !entries[0].isIntersecting; updateSticky();
    }, { threshold: 0, rootMargin: '-40% 0px 0px 0px' }).observe(hero);
  }

  /* ---------- Gallery ---------- */
  var gallery = document.getElementById('gallery');
  if (gallery) {
    var swipeTimer;
    gallery.addEventListener('scroll', function () {
      window.clearTimeout(swipeTimer);
      swipeTimer = window.setTimeout(function () {
        trackOnce('gallery_swipe', { section: 'our_work' });
      }, 250);
    }, { passive: true });
  }

  /* ---------- CTA clicks ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-cta]'), function (cta) {
    cta.addEventListener('click', function () {
      track('cta_click', { cta_location: cta.getAttribute('data-cta') });
    });
  });

  /* ---------- Go ---------- */
  showStep(1);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showSetupNotice);
  } else { showSetupNotice(); }

})();
